fragment GuardrailApprovalFields on Requisition {
  id
  guardrailDecision
  guardrailEvaluation {
    decision
    template
    evaluatedAt
    trigger
    steps {
      order
      kind
      ruleId
      status
      reason
      personId
      actedAt
      groups {
        approverGroupId
        approverGroupName
        status
        personId
        personName
        actedAt
        addingRules {
          ruleId
          ruleName
        }
        elapsedHours
        clockStartedAt
        slaHours
        pastSla
        canRespond
        canUndo
        reasons {
          id
          label
        }
        comment
      }
    }
    checks {
      ruleId
      effect
      state
      detail
    }
  }
}

mutation setWorkforceGuardrailRequestorReason(
  $requisitionId: ID!
  $reason: String!
) {
  result: setWorkforceGuardrailRequestorReason(
    requisitionId: $requisitionId
    reason: $reason
  ) {
    ...GuardrailApprovalFields
  }
}

mutation undoWorkforceGuardrailApprovalStep(
  $requisitionId: ID!
  $order: Int!
  $approverGroupId: ID!
) {
  result: undoWorkforceGuardrailApprovalStep(
    requisitionId: $requisitionId
    order: $order
    approverGroupId: $approverGroupId
  ) {
    ...GuardrailApprovalFields
  }
}

mutation respondWorkforceGuardrailApprovalStep(
  $requisitionId: ID!
  $order: Int!
  $approverGroupId: ID!
  $response: String!
  $reasonIds: [ID!]
  $comment: String
) {
  result: respondWorkforceGuardrailApprovalStep(
    requisitionId: $requisitionId
    order: $order
    approverGroupId: $approverGroupId
    response: $response
    reasonIds: $reasonIds
    comment: $comment
  ) {
    ...GuardrailApprovalFields
  }
}
